import request, { ResponseProps } from '@/utils/request';

interface BatchDetails {
  assetList: {
    id: number;
    type: number; // 1-文件夹，2-图片，3-视频，4-字体,5-音频,6- 音色音频 ，7- zip 文件,8-文本
    title: string;
    desc: string;
    fileUrl: string;
    createTime: string;
    duration: number;
    cover: string;
    customType: string;
    extendInfo: {
      originVideoUrl: string; // 原视频
      originCoverUrl: string; //	原视频封面
      noSubtitlesVideoUrl: string; // 擦除字幕后的视频
      srtUrl: string; // 翻译后 srt
      originSrtUrl: string; //	原文 srt
      targetLanguage: string; // 目标语言
      peopleVoiceUrl: string; // 人声url
      backgroundUrl: string; // 背景音url
      voiceSrtUrl: string; // 音频翻译srtUrl
      voiceJsonUrl: string; // 文本转语音 json 结果
      subtitleProperties: {
        fillColor: number[]; // 填充色
        isStroke: boolean; // 是否描边
        strokeColor: number[];
        strokeWidth: number;
        isBold: boolean; //是否加粗
        fontName: string; // 字体
        startPos: number; // 起始位置
        height: number; // 文字高度
        lineSpacing: number;
      };
    };
  }[];
  taskList: {
    id: number;
    taskId: string; // 引擎返回的任务id
    businessId: string; // 业务id
    type: number; // 任务类型，1-视频制作，2-音频制作，3-视频训练，4-音频训练 5-视频导出 6-视频翻译 7-字幕擦除 8-营销视频制作 9-快速分身训练 10-快速分身导出
    state: number; //状态，0-等待中，1-进行中，2-已完成，3-失败 5-不合规 6-前置任务失败
    processCost: number; // 任务耗时，秒
    createTime: number; //任务发起时间
    videoPreviewUrl: string; //视频封面
    videoTitle: string; //视频标题
    videoUrl: string; //视频url
    engineCode: string; //引擎响应码
    engineMessage: string; //引擎响应信息
  }[];
}

// 获取批次详情
export const getBatchDetail = async (
  batchId: number,
): Promise<ResponseProps<BatchDetails>> => {
  const data = {
    parentId: batchId,
  };

  const res = await request('/api/rest/dlt/cloud/batch/detail', {
    method: 'POST',
    data,
  });

  return res;
};

// 删除任务（主要是失败的）
export const deleteTask = async (taskIds: number[]): Promise<ResponseProps> => {
  const res = await request('/api/rest/dhc/task/delete', {
    method: 'POST',
    data: { taskIds },
  });
  return res;
};
